module.exports = __webpack_public_path__ + "assets/app-store-google.dc91bc2f.svg";